enum CommandState {
  Sleeping,
  Executing,
  Interrupting
}
export default CommandState;
